import { UserRole, type NavItem } from '../types'
import {
    LayoutDashboard,
    Search,
    Wallet,
    Receipt,
    Settings,
    HelpCircle,
    Users,
    CreditCard,
} from 'lucide-react'

// Define navigation items with role-based access
export const navigationConfig: NavItem[] = [
    {
        id: 'dashboard',
        label: 'Dashboard',
        path: '/dashboard',
        icon: LayoutDashboard,
        roles: [UserRole.EMPLOYER, UserRole.AGENT, UserRole.SUPER_ADMIN],
    },
    {
        id: 'investigations',
        label: 'Investigations',
        path: '/investigations',
        icon: Search,
        roles: [UserRole.EMPLOYER, UserRole.AGENT, UserRole.SUPER_ADMIN],
    },
    {
        id: 'transactions',
        label: 'Transactions',
        path: '/transactions',
        icon: Receipt,
        roles: [UserRole.EMPLOYER, UserRole.SUPER_ADMIN],
    },
    {
        id: 'earnings',
        label: 'Earnings',
        path: '/earnings',
        icon: Wallet,
        roles: [UserRole.AGENT],
    },
    {
        id: 'withdrawals',
        label: 'Withdrawals',
        path: '/withdrawals',
        icon: CreditCard,
        roles: [UserRole.AGENT, UserRole.SUPER_ADMIN],
    },
    {
        id: 'users',
        label: 'Users',
        path: '/users',
        icon: Users,
        roles: [UserRole.SUPER_ADMIN],
    },
    {
        id: 'settings',
        label: 'Settings',
        path: '/settings',
        icon: Settings,
        roles: [UserRole.EMPLOYER, UserRole.AGENT, UserRole.SUPER_ADMIN],
    },
    {
        id: 'support',
        label: 'Support',
        path: '/support',
        icon: HelpCircle,
        roles: [UserRole.EMPLOYER, UserRole.AGENT, UserRole.SUPER_ADMIN],
    },
]

// Helper function to filter navigation based on user role
export const getNavigationForRole = (role: UserRole | undefined): NavItem[] => {
    if (!role) {
        return []
    }
    return navigationConfig.filter((item) => item.roles?.includes(role))
}

// Helper function to check if user can request investigation or submit report
export const canRequestInvestigation = (role: UserRole | undefined): boolean => {
    return role === UserRole.EMPLOYER || role === UserRole.AGENT
}
